// page-hatena-account.jsx — Hatena, Account. (会計コンサルティング事業部)
//
// 事業ドメイン:
//   会計業務全体の伴走。会計ソフト導入支援を起点に、
//   既存業務システムとの連携、管理会計、融資支援、
//   経理事務代行までを一気通貫で提供。税務顧問は はてなベース税理士法人 と連携。
//
// 対応プラットフォーム:
//   マネーフォワード・freee・勘定奉行・弥生 ほかのクラウド会計／パッケージ会計
//   周辺は Salesforce / kintone / Looker Studio / Power BI など
//
// 「見える化 / BI ダッシュボード」は Hatena, Data. の役割。当ページでは扱わない。

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;

  // ──────────────────────────────────────────────────────────────
  // 支援領域 — 5 つ + 税務顧問（事務所連携）※ Issue #82: IT導入補助金の活用支援を削除
  // ──────────────────────────────────────────────────────────────
  const SCOPE = [
    {
      num: '01', en: 'Implementation',
      jp: '会計ソフトの導入支援',
      d: 'マネーフォワードや freee などのクラウド会計、勘定奉行などのパッケージ会計まで。組織規模・既存システム・上場フェーズに合うものを選定し、初期設計から月次決算が回る状態までを伴走します。',
    },
    {
      num: '02', en: 'Integration',
      jp: '既存業務システムとの会計連携',
      d: 'Salesforce・kintone・販売管理 SaaS・基幹システム・銀行・経費精算など、会計ソフトに数値が流れ込む手前の業務システムとの連携を設計します。スプレッドシート / GAS / API 直結いずれの構成にも対応。',
    },
    {
      num: '03', en: 'Management Accounting',
      jp: '管理会計・経営レポーティング',
      d: '記帳データから部門別損益・取引先別売上・固定費推移・案件別工数などを引き出し、経営会議で使えるレポートに整えます。BI ダッシュボード化は Hatena, Data. と連携。',
    },
    {
      num: '04', en: 'Capital Raising',
      jp: '資金調達支援',
      d: '融資（創業融資・運転資金・成長資金）、ピッチ資料・事業計画書の作成、銀行・投資家向け数値資料の整備、面談同行・申請支援まで。デットからエクイティまで、ステージに応じた資金調達を会計データから組み立てます。',
    },
    {
      num: '05', en: 'BPO',
      jp: '経理事務代行 ／ 業務オペレーション',
      d: '記帳代行・振込管理・外注費計上・減価償却処理など、月次の会計業務を内部チームと並走しながら巻き取り、属人化を解消します。',
    },
  ];

  // ──────────────────────────────────────────────────────────────
  // 対応プラットフォーム — chip 形式
  // ──────────────────────────────────────────────────────────────
  const PLATFORMS = [
    {
      cat: 'Accounting',
      jp: '会計ソフト',
      items: ['マネーフォワード', 'freee', '勘定奉行（クラウド／オンプレ）', '弥生', 'PCA'],
    },
    {
      cat: 'CRM / SoR',
      jp: 'CRM ／ SoR',
      items: ['Salesforce', 'kintone', 'JustDB', 'HubSpot', 'Zoho CRM', 'Microsoft Dynamics 365', 'Mazrica', 'eセールスマネージャー'],
    },
    {
      cat: 'Workflow / Automation',
      jp: 'ワークフロー・業務自動化',
      items: ['n8n', 'Zapier', 'Make', 'Power Automate', 'ジョブカンワークフロー', '楽楽精算', 'バクラク', 'マネーフォワード Cloud 経費', 'AKASHI'],
    },
    {
      cat: 'Communication',
      jp: 'コミュニケーション基盤',
      items: ['Slack', 'Google Workspace', 'Microsoft 365', 'Teams', 'Chatwork', 'Notion'],
    },
  ];

  // ──────────────────────────────────────────────────────────────
  // 抽象化した支援事例 4 件
  // ※ Issue #82 により支援事例セクションは一旦非表示（描画側で未使用）。
  //    復活時にこのデータをそのまま利用できるよう残置。
  // ──────────────────────────────────────────────────────────────
  const CASES = [
    {
      tag: 'CASE 01',
      industry: 'IT・受託開発企業',
      phase: '4 期目継続支援',
      d: 'クラウド会計と連携した管理会計レポートの運用、税務顧問、資金調達支援（融資・成功報酬型）を一気通貫で提供。創業期から伴走し、4 期目に入ったいまも継続中。税務顧問は はてなベース税理士法人 と連携。',
      stack: ['クラウド会計', '管理会計レポート', '資金調達支援', '振込管理'],
    },
    {
      tag: 'CASE 02',
      industry: '外食チェーン（複数業態運営）',
      phase: '準委任 ／ 業務改善',
      d: '複数業態・売上 100 億円超規模の外食企業に対し、クラウド会計の業務改善を実施。売上計上〜入金管理〜固定資産〜給与連携までの仕組みを、現場経理チームと並走しながら整備。',
      stack: ['クラウド会計', '売上計上設計', '入金管理', '給与連携'],
    },
    {
      tag: 'CASE 03',
      industry: 'まちづくり合同会社',
      phase: 'Phase 3 ／ 実装中',
      d: '地域開発を担う合同会社のクラウド会計をゼロから導入。マスタ設計・タグルール構築・スプレッドシート / Looker Studio 連携によるレポート自動化までを伴走。',
      stack: ['クラウド会計', 'タグ設計', 'スプレッドシート連携', '月次レポート'],
    },
    {
      tag: 'CASE 04',
      industry: '成長フェーズ事業会社',
      phase: '提案・実装',
      d: '記帳体制の再構築と会計 DX ロードマップを策定。投資家向け数値資料の信頼性を担保するためのデータ基盤と業務フローを再設計。提案規模 ¥5M クラス。',
      stack: ['会計 DX', 'DX ロードマップ', '投資家向け資料', 'BPR'],
    },
  ];

  function HatenaAccountPage() {
    return (
      <HBLayout>
        <HBSubHero
          crumb={`Service / 会計業務全体の支援`}
          en="Accounting & Finance Operations"
          jp={<span>経理業務のAX化を中心に<br/><span style={{color:hbcp.blue}}>会計業務全体</span>を再設計する</span>}
          tag={'Redesigning accounting operations, centered on AX.'}
          lead={'会計コンサルティング事業部は、会計業務全体を伴走する事業部です。マネーフォワードや freee などのクラウド会計の導入支援を起点に、既存業務システムとの連携、管理会計・経営レポーティング、融資支援、経理事務代行まで、現場で動く仕組みを一気通貫で組み立てます。税務顧問が必要な場合は はてなベース税理士法人 と連携して対応します。'}
        />

        {/* Scope — 6 areas */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Scope of support</span>
              <span className="hb-section-head-jp">支援領域</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>05 AREAS + TAX</span>
            </div>
            <div style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`, background:hbcp.paper}}>
              {SCOPE.map(s => (
                <div key={s.num} style={{padding:'32px 28px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`, background:'#fff'}}>
                  <div style={{display:'flex', alignItems:'baseline', gap:12, marginBottom:14}}>
                    <span style={{fontFamily:fontEN, fontWeight:300, fontSize:32, color:hbcp.blue, lineHeight:1}}>{s.num}</span>
                    <span style={{fontFamily:fontENSans, fontSize:10.5, letterSpacing:'.28em', fontWeight:700, color:hbcp.inkLight}}>{s.en.toUpperCase()}</span>
                  </div>
                  <h4 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 12px', color:hbcp.ink}}>{s.jp}</h4>
                  <p style={{fontSize:13.5, lineHeight:1.85, color:hbcp.inkSoft, margin:0}}>{s.d}</p>
                </div>
              ))}
              {/* Tax advisor note — はてなベース税理士法人 連携の明示 */}
              <div style={{padding:'32px 28px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`, background:hbcp.paper}}>
                <div style={{display:'flex', alignItems:'baseline', gap:12, marginBottom:14}}>
                  <span style={{fontFamily:fontEN, fontWeight:300, fontSize:32, color:hbcp.blue, lineHeight:1}}>+</span>
                  <span style={{fontFamily:fontENSans, fontSize:10.5, letterSpacing:'.28em', fontWeight:700, color:hbcp.inkLight}}>TAX ADVISORY</span>
                </div>
                <h4 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 12px', color:hbcp.ink}}>税務顧問</h4>
                <p style={{fontSize:13.5, lineHeight:1.85, color:hbcp.inkSoft, margin:'0 0 14px'}}>
                  税務顧問・申告・記帳代行が必要な場合は、グループの <a href={`${HB_BASE}/tax-accountant`} style={{color:hbcp.blue, textDecoration:'underline'}}>はてなベース税理士法人</a> と連携を取り、シームレスに対応します。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Platforms — chip list */}
        <section style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Supported tools</span>
              <span className="hb-section-head-jp">対応するツール</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>EXAMPLES ONLY</span>
            </div>
            <p style={{fontSize:13.5, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 28px', maxWidth:880}}>
              下記はあくまで <strong style={{color:hbcp.ink}}>一例</strong> です。組織の規模・既存環境・予算・コンプライアンス要件に応じて、これら以外のツールも含めてフラットに比較・選定します。特定のベンダーに限定した対応ではありません。
            </p>
            <div style={{display:'grid', gridTemplateColumns:'repeat(2, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`, background:'#fff'}}>
              {PLATFORMS.map(p => (
                <div key={p.cat} style={{padding:'28px 28px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{fontFamily:fontENSans, fontSize:10.5, letterSpacing:'.28em', fontWeight:700, color:hbcp.blue, marginBottom:10}}>● {p.cat.toUpperCase()}</div>
                  <h4 style={{fontFamily:fontJP, fontWeight:700, fontSize:16, lineHeight:1.4, margin:'0 0 14px', color:hbcp.ink}}>{p.jp}</h4>
                  <div style={{display:'flex', flexWrap:'wrap', gap:6}}>
                    {p.items.map(it => (
                      <span key={it} style={{display:'inline-block', padding:'5px 12px', background:hbcp.paper, fontFamily:fontMono, fontSize:11.5, fontWeight:600, color:hbcp.ink, letterSpacing:'.02em'}}>{it}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <p style={{marginTop:18, fontSize:12, lineHeight:1.85, color:hbcp.inkLight}}>
              ※ ご利用中の社内システム・業界特化 SaaS との連携も相談可能です。ここに無いツールについてもお気軽にご相談ください。
            </p>
          </div>
        </section>

        {/* Case studies — Issue #82 により一旦非表示（セクションごとカット）。
            復活させる場合はこのコメントを上記 CASES データを用いた <section> に戻す。 */}

        {/* CTA bottom */}
        <section style={{padding:'96px 32px', background:hbcp.blue, color:'#fff', position:'relative', overflow:'hidden'}}>
          <svg style={{position:'absolute', top:'50%', right:-200, transform:'translateY(-50%)', width:560, height:560, opacity:.18}} viewBox="0 0 560 560">
            {[...Array(12)].map((_,i)=>(<circle key={i} cx="280" cy="280" r={30+i*20} fill="none" stroke="#fff" strokeWidth=".7"/>))}
          </svg>
          <div style={{position:'relative', maxWidth:1280, margin:'0 auto', display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:64, alignItems:'flex-end'}}>
            <div>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', opacity:.85, marginBottom:18}}>● CONTACT — まず "何から手をつけるか" から話す</div>
              <h2 style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(36px, 4.5vw, 56px)', lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 24px'}}>
                まずはお気軽に<br/>ご相談ください
              </h2>
              <p style={{fontSize:15, lineHeight:1.95, opacity:.9, margin:0, maxWidth:560}}>
                組織規模・既存システム・上場フェーズ——どこから手をつけるべきかは、貴社の状況によって変わります。ベンダー横断でフラットに比較しながら、最短距離を一緒に設計します。
              </p>
            </div>
            <div style={{display:'grid', gap:14}}>
              <a href={`${HB_BASE}/contact`} style={{padding:'18px 28px', background:'#fff', color:hbcp.blue, textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:700, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>無料相談を予約する</span>
                <span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={`${HB_BASE}/document-request`} style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>資料請求をする</span>
                <span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* Responsive */}
        <style>{`
          @media (max-width: 900px) {
            section [style*="grid-template-columns: repeat(3, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
          }
          @media (max-width: 720px) {
            .hb-section-head { flex-wrap: wrap !important; }
            section[style*="padding: 96px 32px"] { padding: 56px 16px !important; }
            section [style*="grid-template-columns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            section [style*="grid-template-columns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            section [style*="grid-template-columns: 1.4fr 1fr"] {
              grid-template-columns: 1fr !important;
              gap: 28px !important;
            }
          }
        `}</style>
      </HBLayout>
    );
  }

  Object.assign(window, { HatenaAccountPage });
})();
